import NodeApi from "./requests/node-api";
export default (config) => {
    const request = NodeApi.getInstance().request;
    return request.post(`/account/reveal/v3/member-phone`, config);
};
